import { observer } from 'mobx-react-lite'
import { Button, Typography } from 'shared/ui'
import { ActionCard, ActionMessage } from 'widgets/AgentActions'
import { type CategoryMessageStore } from './store/categoryMessageStore'
import styles from './styles.module.scss'

type ICategoryMessageProps = {
  store: CategoryMessageStore
  label: string
  dotColor: 'green' | 'orange' | 'red'
}

export const CategoryMessage = observer(({ store, label, dotColor }: ICategoryMessageProps) => (
  <div className={styles.category}>
    <div className={styles.categoryLabel}>
      <span className={`${styles.dot} ${styles[`dot_${dotColor}`]}`} />
      <Typography variant={'body-rg-medium'} ariaLabel={label}>
        {label}
      </Typography>
      {store.isModified && (
        <Button
          className={styles.categoryRevert}
          text='Revert to default'
          typeBtn='link'
          contained='primary'
          size='small'
          onClick={store.revertToDefault}
        />
      )}
    </div>
    {store.isAdded ? (
      <ActionCard icon='messageTextCircle02' title='Send message' onDelete={store.remove}>
        <ActionMessage
          control={store.messageStore}
          action={store.model}
          error={store.error || null}
          onErrorReset={() => store.setError('')}
        />
      </ActionCard>
    ) : (
      <Button
        icon='add'
        text='Add message (optional)'
        contained='secondary'
        size='medium'
        onClick={store.add}
      />
    )}
  </div>
))
